import Vue from 'vue'
import Router from 'vue-router'

import { store } from '../main.js'

import Home from './home'
import Login from './login'
import User from './user'
import Profile from './profile'
import Department from './department'
import Company from './company'
import Rooms from './rooms'
import RoomDetails from './room_details'
import WorkstationDetails from './workstation_details'
import Usergroups from './usergroups'
import Branch from './branch'
import ScheduleRooms from './schedule_rooms'
import Terminal from './terminal'
import Confirmation from './confirmation'
import Workstations from './workstation'
import ScheduleWorkstations from './schedule_workstations'
import Blueprint from './blueprint'
import ServicesAdditional from './services_additional'
import Term from './term'
import Tickets from './tickets'
import Configuration from './configuration'

Vue.use(Router);

const router = new Router({
    mode: 'history',
    linkActiveClass: "active",
    hashbang: false,
    routes: [
        Login,
        Home,
        User,
        Profile,
        Department,
        Company,
        Rooms,
        RoomDetails,
        WorkstationDetails,
        Usergroups,
        Branch,
        ScheduleRooms,
        Terminal,
        Confirmation,
        Workstations,
        ScheduleWorkstations,
        Blueprint,
        ServicesAdditional,
        Term,
        Tickets,
        Configuration
    ],
    scrollBehavior() {
        document.getElementById('app').scrollIntoView();
    }
});

router.beforeEach((to, from, next) => {
    const terms = localStorage.getItem('accept_terms');
    const authenticated = localStorage.getItem('token');
    let to_splited = to.path.toString().split('/')
    to_splited = to_splited.filter(part => part !== '')

    if (
        !authenticated &&
        (
            !(['/login'].includes(to.path.toString())) &&
            !(['terminal'].includes(to_splited[0])) &&
            !(['confirmation'].includes(to_splited[0])) &&
            !(['blueprint'].includes(to_splited[0]))
        )
    ) {
        next('/login');

        return true;
    }

    // if (authenticated && to.path.toString() != '/profile/accept_terms' && terms == 0) {
    //     next('/profile/accept_terms');

    //     return true;
    // }

    // if (authenticated && to.path.toString() == '/login') {
    //     next('/');

    //     return true;
    // }

    next();
});

router.afterEach((to, from) => {
    let _name = to.name;
    let _route = to.fullPath;

    if (_name === 'Home') {
        _name = '';
        _route = '';
    }

    store.commit("updateBreadCrumbs", { name: _name, route: _route })
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js